import React from "react";

const FooterFB = () => {
    return (
        <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.747559" width="44" height="44" rx="4" fill="#D7E1F2"/>
            <g clipPath="url(#clip0_4307_854)">
                <path d="M19.0633 34.7476V23.4861H16V19.4314H19.0633V15.9682C19.0633 13.2467 20.8728 10.7476 25.0423 10.7476C26.7305 10.7476 27.9788 10.9049 27.9788 10.9049L27.8805 14.6913C27.8805 14.6913 26.6074 14.6792 25.2181 14.6792C23.7145 14.6792 23.4737 15.3528 23.4737 16.4707V19.4314H28L27.8031 23.4861H23.4737V34.7476H19.0633Z" fill="#0268E3"/>
            </g>
            <defs>
                <clipPath id="clip0_4307_854">
                    <rect width="12" height="24" fill="white" transform="translate(16 10.7476)"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default FooterFB
